import { SET_CONTENT_FILTER } from '../actions/contentFilter'

const initialState = {
  vehicle: '',
  type: '',
  id: ''
}

export default function setContentFilter(state = initialState, action) {
  switch (action.type) {
    case SET_CONTENT_FILTER:
      return {
        ...state,
        vehicle: action.contentVehicle,
        type: action.contentType,
        id: action.contentId
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/contentFilter.js